import React from 'react';

const MongoDB_CreateDB = () => {
  return (
    <div>
      <h1>MongoDB_CreateDB Component</h1>
      <p>This is the MongoDB_CreateDB page.</p>
    </div>
  );
};

export default MongoDB_CreateDB;
